module.exports = __webpack_public_path__ + "static/media/barcode-read.3eb2f515.svg";